<template lang="pug">
  header.no-select(ref="myHeader")
    .header__member
      .center-container
        .pull-left
          router-link.btn-on-air(:to="{name: 'onAir'}")
            span 直播中 On Air
          .arrow-wrap
            .arrow ▲
            .arrow ▲
            .arrow ▲
        .pull-right.user(v-if="isLogin && getUser", v-on:mouseover="userDropdown = true", v-on:mouseout="userDropdown = false")
          .user--name {{ getUser.info.nickname }}
          .user--avatar
            img(src="http://linpohua.com/img/about/mypic.png", :src="getUser.info.picture_url")
          .user-dropdown(v-show="userDropdown", v-on:click="userDropdown = !userDropdown")
            li: router-link(:to="{name: 'user'}") 察看票券
            li: router-link(:to="{name: 'ticketType'}") BYOC 購票
            li: router-link(:to="{name: 'selectArea'}") 劃位 / 座位圖
            li: a(@click="logout") 登出
        .pull-right.user(v-else)
          .login-btn(@click="goLogin") 登入
    .header__main
      .dot
      .center-container
        router-link(:to="{name: 'homepage'}").nav-logo.pull-left
          img(:src="navImages.logo", @click="navActiveStatus = 0")
        .nav-social.pull-right
          .btn(href="#" v-scroll-to="{el: '.gamily', offset: -100}")
            .gamily-logo
          .btn(@click="fbShare")
            .fa.fa-facebook
          router-link(:to="{name: 'ticketType'}").btn.btn--white-o.btn-radius.btn__go-buy BYOC 購票
          router-link(:to="{name: 'selectArea'}").btn.btn--white-o.btn-radius.btn__go-buy 劃位 / 座位圖
          router-link(:to="{name: 'user'}").btn.btn--white-o.btn-radius.btn__go-buy 察看票券
    .header__bottom
      nav.nav-wrap(:class="{ 'open': navToggle }")
        ul.center-container
          li(v-for="(btn, index) in navBtns", @click="goNav(btn, index)", :class="{'actived' : navActiveStatus === index}")
            router-link(:to="{name: btn.link}") {{ btn.name }}
      .btn__nav-switch
        img(:src="navToggle ? '/static/nav-btn-on.png?1' : '/static/nav-btn.png?1'", @click="changeNavToggle")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import logoImage from 'assets/nav-logo.png'

export default {
  name: 'header',
  props: {
    isMobile: {
      type: Boolean
    },
    isLogin: {
      type: Boolean
    },
    navToggle: {
      type: Boolean
    }
  },
  data () {
    return {
      navImages: {
        logo: logoImage
      },
      navBtns: [
        {
          name: '首頁',
          link: 'homepage'
        },
        {
          name: '活動資訊',
          link: 'activity'
        },
        {
          name: 'BYOC相關',
          link: 'about'
        },
        {
          name: 'BYOC英雄榜',
          link: 'hero'
        },
        {
          name: '官方購物',
          link: 'shopping'
        },
        {
          name: '精彩節目',
          link: 'highlights'
        },
        {
          name: '相關QA',
          link: 'QA'
        },
        {
          name: '特別感謝',
          link: 'thanks'
        },
        {
          name: '媒體報導',
          link: 'news'
        }
      ],
      userDropdown: false,
      navActiveStatus: 0
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  /* eslint-disable */
  created: function() {
    console.log('created main')
    window.fbAsyncInit = function() {
      FB.init({
        appId      : '1442987119129471',
        autoLogAppEvents : true,
        xfbml      : true,
        version          : 'v2.10'
      });
      FB.AppEvents.logPageView();
   };

    (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "//connect.facebook.net/zh_TW/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  /* eslint-enable */
  /* global FB */
  methods: {
    fbShare () {
      /* eslint-disable */
      FB.ui({
        method: 'share',
        display: 'popup',
        href: 'http://www.wirforce.com.tw',
        hashtag: '#WirForce2017'
      }, function(response){});
      /* eslint-enable */
    },
    changeNavToggle () {
      this.$emit('update:navToggle', !this.navToggle)
    },
    goLogin () {
      const oauthWindow = window.open('https://oauth.4gamers.com.tw/oauth/authorize?client_id=' + process.env.OAUTH.clientId + '&response_type=code&redirect_uri=' + process.env.OAUTH.redirectUri + '&scope=member.profile.read member.hardware.read member.hardware.write member.notification.read member.notification.write member.games.read member.games.write', 'LoginModal', 'width=600,height=800,scrollbars=no', '_blank')
      let timer = setInterval(function () {
        if (oauthWindow.closed) {
          clearInterval(timer)
          window.location.reload()
        }
      }, 500)
      oauthWindow
    },
    logout () {
      this.userLogout()
      this.$emit('update:isLogin', false)
      if (this.$route.meta.requiredAuth === true) {
        this.$router.push({name: 'homepage'})
      }
    },
    goNav (btn, index) {
      this.navActiveStatus = index
      console.log(btn.name, btn.link, index)
    },
    ...mapActions([
      'userLogout'
    ])
  },
  mounted () {
    for (var i = 0; i < this.navBtns.length; i++) {
      if (this.navBtns[i].link === this.$route.name) {
        this.navActiveStatus = i
      }
    }
    // Passing navHeight to App.vue
    this.$emit('update:navHeight', this.$el.clientHeight)
    // sync navHeight to App.vue after window resize
    window.addEventListener('resize', () => {
      this.$emit('update:navHeight', this.$el.clientHeight)
    }, false)
  },
  watch: {
    // 'navActiveStatus': function () {
    //   console.log(this.navBtns[this.navActiveStatus])
    // },
    'this.$el.clientHeight': function () {
      console.log(this.$el.clientHeight)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'

.btn--white
  background-color: #fff
  color: $red

.btn--white-o
  color: #fff
  background-color: $red
  border: 1px solid #fff
  +transition(all, 0.3s, ease)
  &:hover
    @extend .btn--white

.btn-radius
  +border-radius(999px)


header
  position: fixed
  top: 0
  left: 0
  width: 100%
  z-index: 3
  .header__member
    background-color: $red
    color: #fff
    padding: 8px
    @extend %clearfix
    .btn-on-air
      border: 1px solid #fff
      padding: 3px 8px
      +transform(skew(-15deg))
      font-size: 12px
      cursor: pointer
      float: left
      +transition(all, 0.3s, ease)
      margin-right: 8px
      color: #fff
      text-decoration: none
      &:hover
        background-color: #fff
        color: $red
      span
        display: block
        +transform(skew(15deg))
    .arrow-wrap
      float: left
      .arrow
        float: left
        +transform(rotate(90deg))
        +animation('flash 2s infinite')
        &:nth-child(2)
          animation-delay: 0.5s
        &:nth-child(3)
          animation-delay: 1s
    .user
      position: relative
      +transition(all, 0.3s, ease)
      @extend %clearfix
      // &:hover
      //   padding: 20px
      //   +transform(scale(1.5))
      &--name
        float: left
        font-size: 13px
        margin-right: 8px
        line-height: 200%
        cursor: pointer
      &--avatar
        float: left
        height: 30px
        width: 30px
        +border-radius(50%)
        box-shadow: 0 0 3px #000
        overflow: hidden
        cursor: pointer
        img
          width: 100%
      .login-btn
        border: 1px solid #fff
        color: fff
        +border-radius(999px)
        padding: 1px 8px
        cursor: pointer
        +transition(all, 0.3s, ease)
        &:hover
          background-color: #fff
          color: $red
      .user-dropdown
        position: absolute
        opacity: 1
        top: 100%
        right: 0
        width: 160px
        background-color: $black
        border: 2px solid $red
        list-style: none
        z-index: 999
        padding: 2px
        li
          a
            text-align: center
            display: block
            color: $red-light
            padding: 8px 16px
            text-decoration: none
            cursor: pointer
            +transition(all, 0.3s, ease)
            &:hover
              background-color: $red
              color: #fff
  .header__main
    position: relative
    background: linear-gradient(to right, $black 50%, $red 80%)
    // border-bottom: 5px solid $red
    padding: 10px
    @extend %clearfix
    @media screen and (max-width: 990px)
      padding: 0
    .center-container
      @media screen and (max-width: 990px)
        width: 100% !important
        max-width: 100%
        text-align: center
    .dot
      position: absolute
      left: 0
      top: 0
      background-repeat: no-repeat
      width: 100%
      height: 100%
      display: block
      background:
        image: url("~assets/nav-dot-left.png"), url("~assets/nav-dot-right.png")
        position: left right
        size: contain
    .nav-logo
      position: relative
      display: flex
      justify-content: center
      align-items: center
      z-index: 1
      @media screen and (max-width: 990px)
        float: none !important
        margin-bottom: 12px
        padding-top: 12px
      img
        margin-top: 6px
    .nav-social
      @extend .nav-logo
      @media screen and (max-width: 990px)
        background-color: $red
        width: 100%
        margin: 0 !important
        padding-top: 0
      .btn
        // height: 46px
        float: left
        margin-right: 8px
        +transition(all, 0.3s, ease)
        &:active
          background-color: transparent
          box-shadow: none
        @media screen and (max-width: 990px)
          border: none
      .fa
        color: rgba($black, 0.5)
        font-size: 24px
        +transition(color, 0.3s, ease)
        margin-top: 6px
        &:hover
          color: rgba(#fff, 0.9)
      .btn__go-buy
        padding: 6px 18px
        @media screen and (max-width: 990px)
          position: relative
          width: 33.3333%
          float: left
          text-align: center
          background-color: $red
          color: #fff
          padding: 14px
  .header__bottom
    nav.nav-wrap
      border-bottom: 5px solid $red
      background-color: rgba(#0c0c0c, 0.7)
      max-height: 0
      overflow: hidden
      +transition(max-height, 0.3s, ease-out)
      &.open
        max-height: 100px
      .center-container
        list-style: none
        @extend %clearfix
        display: flex
        li
          flex: 1
          -webkit-flex-align: stretch
          flex-align: stretch
          display: flex
          &.actived
            box-shadow: inset 0 0 30px $red
            // background:
            //   image: linear-gradient(to bottom, transparent 55%, rgba(224,37,63,0.8) 100%)
            //   size: 120%
            a
              &:hover
                color: #fff
          a
            flex: 1
            font-weight: bold
            padding: 20px 13px
            color: #fff
            cursor: pointer
            text-align: center
            text-decoration: none
            +transition(background, 0.3s, ease)
            &:hover
              color: $red

    .btn__nav-switch
      position: absolute
      left: 50%
      transform: translateX(-50%)
      height: 33px
      +animation("navBtn 2s infinite")
      img
        display: block
        margin: 0 auto
        cursor: pointer
        +transition(all, 0.3s, ease)
        &:hover
          -webkit-filter: drop-shadow(0 3px 8px rgba(255,0,0,0.5))
          filter: drop-shadow(0 3px 8px rgba(255,0,0,0.5))
          -ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=3, Color='#ff0000')"
          filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=3, Color='#ff0000')"
.gamily-logo
  width: 30px
  height: 30px
  transform: translateY(2px)
  opacity: 0.6
  background:
    // image: url("~assets/ic_soul_b.png")
    image: url("~assets/ic_soul_w.png")
    size: contain
    repeat: no-repeat
  +transition(all, 0.3s, ease)
  &:hover
    opacity: 1
    background:
      image: url("~assets/ic_soul_w.png")
</style>



// WEBPACK FOOTER //
// vueHeader.vue?4bb7542e